import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import { type ReactNode, useCallback, useState } from 'react'

type ErrorDialogState =
  | {
      title: string
      message: string
    }
  | undefined

/**
 * MUI Dialog ベースのエラーダイアログを提供するフック。
 * 呼び出し側は `errorDialog` を JSX 内でレンダリングし、
 * `showError` でダイアログを表示する。
 */
export const useErrorDialog = (): {
  showError: (title: string, message: string) => void
  errorDialog: ReactNode
} => {
  const [state, setState] = useState<ErrorDialogState>(undefined)

  const showError = useCallback((title: string, message: string) => {
    setState({ title, message })
  }, [])

  const handleClose = useCallback(() => {
    setState(undefined)
  }, [])

  const errorDialog = state ? (
    <Dialog open onClose={handleClose}>
      <DialogTitle>{state.title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{state.message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>OK</Button>
      </DialogActions>
    </Dialog>
  ) : undefined

  return { showError, errorDialog }
}
